// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (common trailer) */

.bcd-cell-text-wrapper {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  @media (width >= /* \$screen-sm */ 426px) {
    flex-direction: column;
    align-items: center;
  }
}

.bcd-timeline-cell-text-wrapper {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
}

.bcd-cell-text-copy {
  color: var(--compat-text-primary);
}

.bc-supports-yes {
  .bcd-cell-text-copy {
    color: var(--compat-text-primary-green);
  }
}

.bc-supports-partial {
  .bcd-cell-text-copy {
    color: var(--compat-text-primary-yellow);
  }
}

.bc-supports-no {
  .bcd-cell-text-copy {
    color: var(--compat-text-primary-red);
  }
}

.bcd-cell-icons {
  display: flex;
  gap: 0.5rem;

  @media (width >= /* \$screen-sm */ 426px) {
    display: block;
  }
}

@media (width >= /* \$screen-sm */ 426px) {
  .bc-table {
    td.bc-support > button {
      padding-top: 0.5rem;
      padding-right: 0.25rem;
      padding-bottom: calc(0.5rem + var(--compat-padding-bottom-offset, 0px));
      padding-left: 0.25rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/index-trailer.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;;EAEX;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE;MACE,mBAAmB;MACnB,sBAAsB;MACtB,uEAAuE;MACvE,qBAAqB;IACvB;EACF;AACF","sourcesContent":["/* Compat (common trailer) */\n\n.bcd-cell-text-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n\n  @media (width >= /* $screen-sm */ 426px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.bcd-timeline-cell-text-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 0.25rem;\n}\n\n.bcd-cell-text-copy {\n  color: var(--compat-text-primary);\n}\n\n.bc-supports-yes {\n  .bcd-cell-text-copy {\n    color: var(--compat-text-primary-green);\n  }\n}\n\n.bc-supports-partial {\n  .bcd-cell-text-copy {\n    color: var(--compat-text-primary-yellow);\n  }\n}\n\n.bc-supports-no {\n  .bcd-cell-text-copy {\n    color: var(--compat-text-primary-red);\n  }\n}\n\n.bcd-cell-icons {\n  display: flex;\n  gap: 0.5rem;\n\n  @media (width >= /* $screen-sm */ 426px) {\n    display: block;\n  }\n}\n\n@media (width >= /* $screen-sm */ 426px) {\n  .bc-table {\n    td.bc-support > button {\n      padding-top: 0.5rem;\n      padding-right: 0.25rem;\n      padding-bottom: calc(0.5rem + var(--compat-padding-bottom-offset, 0px));\n      padding-left: 0.25rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
